import {CanvasMode} from "../../model/CanvasMode"
import {CanvasPosition} from "../../model/CanvasPosition"
import {canvasContentService} from "../../services/canvasContentService"

export interface ProcessClickParams {
    mode: CanvasMode
    canvasPosition: CanvasPosition
    ctrlKey: boolean
    canvasId: string
    canvasSelection: Array<string>
    canvasContent: { widgets: Array<any>, widgetLinks: Array<any> }
    layerIds: Array<string>
    onChangeSelection: (selection: Array<string>) => void
    onStartEdit: (widgetId: string) => void
    onChangeTool: (newTool: CanvasMode) => void,
    alignToGrid?: boolean,
}

export const processCanvasClick = ({
    mode,
    canvasPosition,
    ctrlKey,
    canvasId,
    canvasSelection,
    canvasContent,
    layerIds,
    onChangeSelection,
    onStartEdit,
    onChangeTool,
    alignToGrid,
}: ProcessClickParams): void => {
    canvasContentService.processClick(
        mode,
        canvasPosition,
        ctrlKey,
        canvasId,
        canvasSelection,
        canvasContent,
        layerIds,
        onChangeSelection,
        onStartEdit,
        onChangeTool,
        alignToGrid,
    )
}
